export const adminStats = {
  totalUsers: 2847,
  newUsersThisMonth: 156,
  totalCourses: 6,
  activeStudents: 1230,
  totalPayments: 458000000,
  paymentsThisMonth: 24500000,
  totalAuctionItems: 156,
  pendingConsultations: 12,
  monthlyRevenue: [420, 380, 510, 480, 620, 550, 680, 720, 590, 810, 760, 890],
  userGrowth: [120, 150, 180, 210, 240, 260, 290, 310, 340, 360, 380, 410],
  coursePopularity: [
    { name: "경매 입문", students: 2340 },
    { name: "권리분석", students: 1250 },
    { name: "입찰가 산정", students: 890 },
    { name: "명도실무", students: 670 },
    { name: "매매사업자", students: 430 },
    { name: "오프라인 특강", students: 310 },
  ],
};

export const adminUsers = [
  { id: "u1", name: "김민수", email: "minsu@email.com", phone: "010-1234-5678", grade: "일반", enrolledCourses: 4, totalPaid: 1049000, joinedAt: "2026-02-15", lastLogin: "2026-05-27" },
  { id: "u2", name: "이지은", email: "jieun@email.com", phone: "010-2345-6789", grade: "일반", enrolledCourses: 3, totalPaid: 650000, joinedAt: "2026-02-22", lastLogin: "2026-05-26" },
  { id: "u3", name: "박성호", email: "sungho@email.com", phone: "010-3456-7890", grade: "VIP", enrolledCourses: 5, totalPaid: 1850000, joinedAt: "2026-01-10", lastLogin: "2026-05-27" },
  { id: "u4", name: "최유진", email: "yujin@email.com", phone: "010-4567-8901", grade: "구독", enrolledCourses: 4, totalPaid: 1200000, joinedAt: "2026-03-05", lastLogin: "2026-05-25" },
  { id: "u5", name: "정대호", email: "daeho@email.com", phone: "010-5678-9012", grade: "일반", enrolledCourses: 2, totalPaid: 350000, joinedAt: "2026-04-01", lastLogin: "2026-05-24" },
  { id: "u6", name: "한소희", email: "sohee@email.com", phone: "010-6789-0123", grade: "일반", enrolledCourses: 3, totalPaid: 450000, joinedAt: "2026-03-18", lastLogin: "2026-05-23" },
  { id: "u7", name: "강동원", email: "dongwon@email.com", phone: "010-7890-1234", grade: "VIP", enrolledCourses: 6, totalPaid: 2200000, joinedAt: "2026-01-05", lastLogin: "2026-05-27" },
  { id: "u8", name: "배수지", email: "suzy@email.com", phone: "010-8901-2345", grade: "일반", enrolledCourses: 1, totalPaid: 0, joinedAt: "2026-05-20", lastLogin: "2026-05-22" },
];

export const adminCourses = [
  { id: "c1", title: "경매 입문 클래스", type: "무료", students: 2340, price: 0, lectures: 12, revenue: 0, status: "운영중", createdAt: "2026-01-15" },
  { id: "c2", title: "권리분석 마스터 과정", type: "유료", students: 1250, price: 350000, lectures: 16, revenue: 437500000, status: "운영중", createdAt: "2026-02-01" },
  { id: "c3", title: "입찰가 산정 실전반", type: "유료", students: 890, price: 450000, lectures: 10, revenue: 400500000, status: "운영중", createdAt: "2026-03-01" },
  { id: "c4", title: "명도실무 완전정복", type: "유료", students: 670, price: 300000, lectures: 8, revenue: 201000000, status: "운영중", createdAt: "2026-03-15" },
  { id: "c5", title: "매매사업자 실전 과정", type: "실전", students: 430, price: 550000, lectures: 20, revenue: 236500000, status: "운영중", createdAt: "2026-04-01" },
  { id: "c6", title: "오프라인 특강", type: "오프라인", students: 310, price: 200000, lectures: 4, revenue: 62000000, status: "준비중", createdAt: "2026-05-01" },
];

export const adminPayments = [
  { id: "p1", user: "김민수", type: "강의", item: "권리분석 마스터 과정", amount: 350000, status: "완료", method: "카드", date: "2026-03-10" },
  { id: "p2", user: "박성호", type: "강의", item: "매매사업자 실전 과정", amount: 550000, status: "완료", method: "계좌이체", date: "2026-04-05" },
  { id: "p3", user: "이지은", type: "리포트", item: "서울 지역분석 리포트", amount: 199000, status: "완료", method: "카드", date: "2026-04-20" },
  { id: "p4", user: "최유진", type: "강의", item: "입찰가 산정 실전반", amount: 450000, status: "완료", method: "카드", date: "2026-05-01" },
  { id: "p5", user: "정대호", type: "리포트", item: "필수 체크리스트", amount: 49000, status: "완료", method: "카카오페이", date: "2026-05-15" },
  { id: "p6", user: "한소희", type: "강의", item: "명도실무 완전정복", amount: 300000, status: "완료", method: "카드", date: "2026-05-18" },
  { id: "p7", user: "강동원", type: "강의", item: "권리분석 마스터 과정", amount: 350000, status: "완료", method: "계좌이체", date: "2026-05-20" },
  { id: "p8", user: "박성호", type: "리포트", item: "경기남부 분석 리포트", amount: 159000, status: "환불", method: "카드", date: "2026-05-22" },
];

export const adminAuctionItems = [
  { id: "a1", caseNumber: "2025타경12345", court: "서울중앙지방법원", location: "서울 강남구 역삼동", type: "아파트", minPrice: 580000000, grade: "A", auctionDate: "2026-06-15", status: "입찰예정" },
  { id: "a2", caseNumber: "2025타경23456", court: "수원지방법원", location: "경기 용인시 수지구", type: "아파트", minPrice: 320000000, grade: "B", auctionDate: "2026-06-20", status: "입찰예정" },
  { id: "a3", caseNumber: "2026타경34567", court: "인천지방법원", location: "인천 서구 청라동", type: "오피스텔", minPrice: 180000000, grade: "A", auctionDate: "2026-07-05", status: "입찰예정" },
  { id: "a4", caseNumber: "2025타경45678", court: "서울동부지방법원", location: "서울 송파구 잠실동", type: "아파트", minPrice: 720000000, grade: "A", auctionDate: "2026-06-10", status: "입찰예정" },
  { id: "a5", caseNumber: "2025타경56789", court: "부산지방법원", location: "부산 해운대구 우동", type: "아파트", minPrice: 450000000, grade: "B", auctionDate: "2026-07-15", status: "입찰예정" },
  { id: "a6", caseNumber: "2025타경67890", court: "대구지방법원", location: "대구 수성구 범어동", type: "아파트", minPrice: 380000000, grade: "C", auctionDate: "2026-08-01", status: "분석중" },
];

export const adminConsultations = [
  { id: "c1", user: "김민수", type: "1:1 상담", date: "2026-06-12", time: "오후 3:00", status: "예정", assignedTo: "강현우" },
  { id: "c2", user: "이지은", type: "물건분석", date: "2026-06-08", time: "오전 11:00", status: "배정", assignedTo: "강현우" },
  { id: "c3", user: "정대호", type: "매매사업자", date: "2026-06-10", time: "오후 7:00", status: "신청", assignedTo: null },
  { id: "c4", user: "한소희", type: "1:1 상담", date: "2026-06-15", time: "오후 4:00", status: "신청", assignedTo: null },
  { id: "c5", user: "최유진", type: "물건분석", date: "2026-06-05", time: "오후 2:00", status: "완료", assignedTo: "강현우" },
  { id: "c6", user: "박성호", type: "1:1 상담", date: "2026-06-01", time: "오전 10:00", status: "완료", assignedTo: "강현우" },
];

export const adminNotifications = [
  { id: "n1", type: "전체", title: "6월 오프라인 특강 오픈 안내", sentAt: "2026-05-26", sentCount: 2847, method: "카카오톡" },
  { id: "n2", type: "VIP", title: "VIP 회원 특별 할인 이벤트", sentAt: "2026-05-20", sentCount: 320, method: "문자" },
  { id: "n3", type: "전체", title: "홈페이지 리뉴얼 오픈 안내", sentAt: "2026-05-15", sentCount: 2800, method: "이메일" },
  { id: "n4", type: "구독", title: "신규 리포트 출시 알림", sentAt: "2026-05-10", sentCount: 450, method: "카카오톡" },
];

export const adminTabs = [
  { key: "dashboard", label: "대시보드", icon: "ri-dashboard-line" },
  { key: "users", label: "회원 관리", icon: "ri-user-line" },
  { key: "courses", label: "교육 관리", icon: "ri-book-open-line" },
  { key: "payments", label: "결제 관리", icon: "ri-bank-card-line" },
  { key: "auctions", label: "물건 관리", icon: "ri-auction-line" },
  { key: "upload", label: "엑셀 업로드", icon: "ri-file-excel-2-line" },
  { key: "awarded", label: "낙찰물건 관리", icon: "ri-check-double-line" },
  { key: "awarded-upload", label: "낙찰물건 업로드", icon: "ri-file-excel-2-line" },
  { key: "analysis", label: "분석 보고서", icon: "ri-bar-chart-2-line" },
  { key: "inbox", label: "폼 접수함", icon: "ri-inbox-line" },
  { key: "consultations", label: "상담 관리", icon: "ri-customer-service-2-line" },
  { key: "notifications", label: "알림 발송", icon: "ri-notification-3-line" },
];